import { render, staticRenderFns } from "./TemplateFormInfo.vue?vue&type=template&id=2f9178b3&scoped=true"
import script from "./TemplateFormInfo.vue?vue&type=script&lang=js"
export * from "./TemplateFormInfo.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormInfo.vue?vue&type=style&index=0&id=2f9178b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9178b3",
  null
  
)

export default component.exports